import { FormDatePicker } from 'src/components/forms/components/FormDatePicker';
import { FormInput } from 'src/components/forms/components/FormInput';
import { FormRow } from 'src/components/forms/layout/FormRow';

export const CustomerInfo = () => {
  return (
    <>
      <FormRow>
        <FormInput
          name="firstName"
          label="First Name"
          placeholder="Enter First Name"
          bg="white"
          hideOptionalLabel
          controlStyleProps={{ maxWidth: { base: '100%', sm: '320px' } }}
        />
        <FormInput
          name="middleName"
          label="Middle Name"
          placeholder="Enter Middle Name"
          bg="white"
          hideOptionalLabel
          controlStyleProps={{ maxWidth: { base: '100%', sm: '320px' } }}
        />
        <FormInput
          name="lastName"
          label="Last Name"
          placeholder="Enter Last Name"
          bg="white"
          hideOptionalLabel
          controlStyleProps={{ maxWidth: { base: '100%', sm: '320px' } }}
        />
      </FormRow>
      <FormRow>
        <FormInput
          name="customerNumber"
          label="Customer Number"
          placeholder="Enter Customer Number"
          bg="white"
          hideOptionalLabel
          controlStyleProps={{ maxWidth: { base: '100%', sm: '320px' } }}
        />
        <FormDatePicker
          name="dateOfBirth"
          label="Date of Birth"
          hideOptionalLabel
          controlStyleProps={{ width: '200px' }}
          datePickerOptions={{
            maxDate: new Date(),
          }}
        />
      </FormRow>
    </>
  );
};
